<template>
  <footer class="site-footer">
    <div class="w1280 site-footer__inner">
      <div class="site-footer__brand">
        <span class="site-footer__eyebrow">QE / OFFICIAL WEBSITE</span>
        <p class="site-footer__title">AIGC 合成数据与场景应用</p>
        <p class="site-footer__summary">
          查看合成数据引擎、行业应用、示例数据与研究资料，快速了解 QE 的产品能力与合作方式。
        </p>
      </div>

      <div class="site-footer__links">
        <router-link to="/">首页</router-link>
        <router-link to="/Product?id=8">产品与应用</router-link>
        <router-link to="/Resource">资源中心</router-link>
        <router-link to="/about">关于我们</router-link>
      </div>

      <div class="site-footer__meta">
        <p>电话：010-62017543</p>
        <p>邮箱：qe@ai-quants.com</p>
        <p>地址：北京市西城区新街口外大街28号普天德胜C座609</p>
      </div>
    </div>

    <div class="w1280 site-footer__legal">
      <span>Copyright 2019-2026 | 北京宽客进化科技有限公司</span>
      <span class="site-footer__records">
        <a href="https://beian.miit.gov.cn/" target="_blank" rel="noreferrer">京ICP备19027470号-1</a>
      </span>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'SiteFooter',
}
</script>

<style lang="less" scoped>
.site-footer {
  margin-top: 80px;
  padding: 28px 0 32px;
  border-top: 1px solid rgba(17, 17, 17, 0.08);
  background: rgba(239, 239, 239, 0.95);
}

.site-footer__inner {
  display: grid;
  grid-template-columns: 1.5fr 1fr 1.1fr;
  gap: 32px;
  padding: 20px 0 28px;
}

.site-footer__eyebrow {
  display: inline-block;
  margin-bottom: 12px;
  color: var(--accent);
  font-size: 11px;
  letter-spacing: 0.22em;
  text-transform: uppercase;
}

.site-footer__title {
  margin-bottom: 10px;
  color: var(--text-strong);
  font-size: clamp(1.25rem, 2vw, 1.75rem);
  font-weight: 600;
  line-height: 1.2;
}

.site-footer__summary,
.site-footer__meta p,
.site-footer__legal {
  color: var(--text-muted);
  font-size: 13px;
  line-height: 1.8;
}

.site-footer__links {
  display: grid;
  gap: 12px;
  align-content: start;
}

.site-footer__links a {
  color: var(--text-strong);
  font-size: 13px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.site-footer__links a:hover,
.site-footer__records a:hover {
  color: var(--accent);
}

.site-footer__legal {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding-top: 20px;
  border-top: 1px solid rgba(17, 17, 17, 0.08);
}

.site-footer__records {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.site-footer__records a {
  color: inherit;
}

@media (max-width: 960px) {
  .site-footer {
    margin-top: 56px;
  }

  .site-footer__inner,
  .site-footer__legal {
    grid-template-columns: 1fr;
    display: grid;
    gap: 20px;
  }

  .site-footer__legal {
    justify-content: flex-start;
  }

  .site-footer__records {
    gap: 12px 20px;
  }
}
</style>
